import React, { forwardRef } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className = '',
  variant = 'primary',
  size = 'lg',
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5A7D60] disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#5A7D60] text-white hover:bg-[#4A6850] shadow-lg shadow-[#5A7D60]/20',
    secondary: 'bg-[#F5F0E8] text-[#3D3229] hover:bg-[#EBE5DB]',
    outline: 'border-2 border-[#5A7D60] text-[#5A7D60] hover:bg-[#5A7D60]/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-210">
        {children}
      </motion.button>;
});
Button.displayName = 'Button';